<ion-header>
  <ion-toolbar>
    <ion-back-button slot="start" (click)="back()" text=""></ion-back-button>
    <ion-title>Kundenanmeldung</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div *ngIf="!isLoading">
    <h1>Kundenanmeldung</h1>
  
    <h2>Art des neuen Tickets</h2>
    <div class="filter-bttn" (click)="selectArt($event)">
      <span *ngIf="!selectedArt" style="opacity: 0.5;">Art...</span>
      <span *ngIf="selectedArt">{{selectedArt.description}}</span>
      <svg _ngcontent-mym-c168="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sort-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-sort-down"><path _ngcontent-mym-c168="" fill="currentColor" d="M311.9 335.1l-132.4 136.8C174.1 477.3 167.1 480 160 480c-7.055 0-14.12-2.702-19.47-8.109l-132.4-136.8C-9.229 317.8 3.055 288 27.66 288h264.7C316.9 288 329.2 317.8 311.9 335.1z"></path></svg>
    </div>
    
    <h2>E-Mails an Ansprechpartner bei neuem Eintrag</h2>
    <div class="filter-bttn" (click)="selectMailSend($event)">
      <span *ngIf="customerLogin.sendMail == 1">Aus</span>
      <span *ngIf="customerLogin.sendMail == 2">Immer nachfragen</span>
      <span *ngIf="customerLogin.sendMail == 3">Immer senden</span>
      <svg _ngcontent-mym-c168="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sort-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-sort-down"><path _ngcontent-mym-c168="" fill="currentColor" d="M311.9 335.1l-132.4 136.8C174.1 477.3 167.1 480 160 480c-7.055 0-14.12-2.702-19.47-8.109l-132.4-136.8C-9.229 317.8 3.055 288 27.66 288h264.7C316.9 288 329.2 317.8 311.9 335.1z"></path></svg>
    </div>
  
    <h2>Zuweisung eines neuen Tickets</h2>
    <ion-segment mode="ios" [(ngModel)]="customerLogin.allocationType">
      <ion-segment-button value="group">Gruppe</ion-segment-button>
      <ion-segment-button value="employee">Mitarbeiter</ion-segment-button>
    </ion-segment>
  
    <div *ngIf="customerLogin.allocationType == 'group'">
      <h2>Zugewiesene Gruppe</h2>
      <div class="filter-bttn" (click)="selectGroup($event)">
        <span *ngIf="!selectedGroup" style="opacity: 0.5;">Gruppe...</span>
        <span *ngIf="selectedGroup">{{selectedGroup.description}}</span>
        <svg _ngcontent-mym-c168="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sort-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-sort-down"><path _ngcontent-mym-c168="" fill="currentColor" d="M311.9 335.1l-132.4 136.8C174.1 477.3 167.1 480 160 480c-7.055 0-14.12-2.702-19.47-8.109l-132.4-136.8C-9.229 317.8 3.055 288 27.66 288h264.7C316.9 288 329.2 317.8 311.9 335.1z"></path></svg>
      </div>
    </div>
  
    <div *ngIf="customerLogin.allocationType == 'employee'">
      <h2>Zugewiesene Mitarbeiter</h2>
      <ion-item class="employee" *ngFor="let employee of ticketEditSrv.employees" (click)="switchEmployee(employee)" [class.active]="customerLogin.employees.includes(employee.id)">
        <ion-label>{{employee.firstName}} {{employee.lastName}}</ion-label>
      </ion-item>
    </div>
  </div>

  <section id="loading" *ngIf="isLoading">
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner-third" class="svg-inline--fa fa-spinner-third fa-w-16 spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#fff" d="M283.2 65.92C267.6 63.69 256 50.32 256 34.52c0-19.38 17.19-34.69 36.38-31.95C416.4 20.29 512 127.2 512 256c0 33.38-6.544 65.26-18.27 94.49c-7.162 17.86-28.85 24.87-45.56 15.32c-13.74-7.854-19.62-24.53-13.75-39.23C443.2 304.7 448 280.9 448 256C448 159.4 376.3 79.18 283.2 65.92z"></path></svg>
  </section>

</ion-content>

<ion-footer>
  <ion-toolbar class="ion-padding" style="padding-top: 0;">
    <div class="button main-button" (click)="save()">Speichern</div>
  </ion-toolbar>
</ion-footer>
